import { z } from 'zod';
import { legalClientSchema } from '../ILegalClient';
import { legalTransactionSchema } from '../ILegalTransaction';

export const legalTransactionRelationshipMemberSchema = z.object({
  FirstName: z.string().nullable(),
  LastName: z.string(),
  LegalClient: legalClientSchema,
  LegalTransactionArray: z.array(legalTransactionSchema),
  RelationshipRole: z.string().nullable().optional(),
  idLegalClient: z.number(),
  idLegalClientRelationship: z.number(),
  idRelationship: z.number(),
  idRelationshipRole: z.number(),
  isActiveLegalClientRelationship: z.boolean(),
  Joined_At: z.string().nullable().optional(),
  Last_Update: z.string().nullable().optional(),
});

export type ILegalTransactionRelationshipMember = z.infer<
  typeof legalTransactionRelationshipMemberSchema
>;
